module.exports = __webpack_public_path__ + "media/images/favicon-32x32-66f20fd7d951ec2f5436c3602220dfda.png";